import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=3a212edd&scoped=true&"
import script from "./PermissionDenied.vue?vue&type=script&lang=js&"
export * from "./PermissionDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a212edd",
  null
  
)

export default component.exports